<div class="icon-nav">
  <ul>
    <li class="onhover-div mobile-search search-widgets" id="search-widgets">
      <div (click)="searchToggle()">
        <i class="ti-search"></i>
      </div>
      <div id="search-overlay" class="search-overlay" [ngStyle]="{'display': search ? 'block' : 'none' }">
        <div>
          <span class="closebtn" title="Close Overlay" (click)="searchToggle()">×</span>
          <div class="overlay-content">
            <div class="container">
              <div class="row">
                <div class="col-xl-12">
                  <form>
                    <div class="form-group">
                      <input [(ngModel)]="searchTerm" type="text" class="form-control" id="exampleInputPassword1"
                        name="searchTerm" placeholder="Buscar producto por nombre"
                        (keypress)="validateSearchTerm($event)">
                    </div>
                  </form>
                </div>
                <div class="col-xl-12 d-flex justify-content-center mt-5">
                  <button (click)="submit()" class="btn-solid" style="font-size: 14px !important;">BUSCAR</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </li>
    <li class="onhover-div mobile-shuffle" data-bs-toggle="tooltip" data-bs-placement="bottom" title="Comparar">
      <div>
        <a [routerLink]="['/shop/compare']">
          <i class="ti-control-shuffle"></i>
        </a>
      </div>
    </li>
    <li class="onhover-div mobile-cart" >
      <div>
        <a [routerLink]="['/shop/cart']">
          <i class="ti-shopping-cart"></i>
        </a>
      </div>
      <span class="cart_qty_cls">{{ getCantTotal | async }}</span>
      <ul class="show-div shopping-cart" *ngIf='!products?.length'>
        <h5>Su carrito está vacío.</h5>
      </ul>
      <ul class="show-div shopping-cart" *ngIf='products?.length'>
        <li *ngFor="let product of products" style="overflow: hidden !;">
          <div class="media">
            <a [routerLink]="['/shop/product/left/sidebar/', product.title.replace(' ', '-')]">
              <img class="me-3" [src]="product?.image" [alt]="product?.title">
            </a>
            <div class="media-body">
              <a [routerLink]="['/shop/product/left/sidebar/', product.title.replace(' ', '-')]">
                <h4>{{ product?.title }}</h4>
              </a>
              <h4>
                <span>
                  {{ product?.quantity }} x
                  {{ product.tienePromocion ? (product.priceDiscount |
                  currency:productService?.Currency.currency:'symbol') : (product.price |
                  currency:productService?.Currency.currency:'symbol') }}
                </span>
              </h4>
            </div>
          </div>
        </li>
        <li>
          <div class="buttons">
            <a [routerLink]="['/shop/cart']" class="view-cart">Ver carrito</a>
            <a [routerLink]="['/shop/checkout']" class="checkout">Comprar</a>
          </div>
        </li>
      </ul>
    </li>
  </ul>
</div>